import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useMicrosoftAuth } from '../context/MicrosoftAuthContext';
import api from '../api/axios';

const MicrosoftProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, accessToken } = useMicrosoftAuth();
  const navigate = useNavigate();

  // Ensure the API token is set
  useEffect(() => {
    if (accessToken) {
      api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    } else {
      // Try to get token from localStorage
      const token = localStorage.getItem('msalToken');
      if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
    }
  }, [accessToken]);

  // Effect to redirect when authentication state changes
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-black" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Return null during redirect to avoid flashing content
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render children if authenticated
  return children;
};

export default MicrosoftProtectedRoute; 